import { type ButtonHTMLAttributes, forwardRef } from 'react'
import { CloseIcon } from '@/icons'
import { closeButtonVariants } from './CloseButton.variants'

export interface CloseButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  size?: 'sm' | 'md' | 'lg'
  variant?: 'default' | 'ghost'
}

export const CloseButton = forwardRef<HTMLButtonElement, CloseButtonProps>(
  ({ size = 'md', variant = 'default', className, children, ...props }, ref) => {
    return (
      <button
        className={closeButtonVariants({ size, variant, className })}
        ref={ref}
        type="button"
        {...props}
      >
        {children || <CloseIcon className="w-full h-full" />}
      </button>
    )
  }
)

CloseButton.displayName = 'CloseButton'